/** @deprecated Use `digitsToHindi in @bale/utils` instead */
export const digitsToHindi = (number) => {
    var _a;
    const hindiDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    return ((_a = number === null || number === void 0 ? void 0 : number.replace(/[0-9]/g, function (w) {
        return hindiDigits[Number(w)];
    })) !== null && _a !== void 0 ? _a : "");
};
const persianNumbers = [
    /۰/g,
    /۱/g,
    /۲/g,
    /۳/g,
    /۴/g,
    /۵/g,
    /۶/g,
    /۷/g,
    /۸/g,
    /۹/g,
];
const arabicNumbers = [
    /٠/g,
    /١/g,
    /٢/g,
    /٣/g,
    /٤/g,
    /٥/g,
    /٦/g,
    /٧/g,
    /٨/g,
    /٩/g,
];
export const digitsToLatin = (inputNumber) => {
    let result = inputNumber;
    if (typeof result === "string") {
        new Array(10).fill(0).map((e, index) => {
            result = result
                .replace(persianNumbers[index], String(index))
                .replace(arabicNumbers[index], String(index));
        });
    }
    return result;
};
export function toMoneyFormat(value) {
    const v = value.replace(/,/g, "");
    if (!v)
        return "";
    if (v.length < 3)
        return v;
    return v.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
}
export function fromMoneyFormats(value) {
    const v = value.replace(/,/g, "");
    if (!v)
        return "";
    if (v === "0" || v === "۰") {
        return v;
    }
    return v.replace(/^[0۰]+/g, "");
}
//# sourceMappingURL=numbers.js.map